<template>

  <MenuBoxText />
  
  <section class="boxsection boxtxt" id="Informations">
    <h1>List of possible co-seismic displacements recorded by IGS stations</h1>
    The table below is generated automatically based on the following procedure: 
    <ul> 
        <li><a href="https://www.globalcmt.org/">The Global Centroid-Moment-Tensor (CMT) catalog</a> is scanned every day for new earthquakes.</li>
        <li>For every earthquake in the CMT catalog, the width, length and slip of the rupture are estimated from:
            <ul>
              <li><a href="https://doi.org/10.1785/0120100046">Yen & Ma (2012)</a>'s scaling law if the earthquake magnitude is less than 7.6;</li>
              <li><a href="https://doi.org/10.1785/0119990126">Mai & Beroza (2000)</a>'s scaling law it the earthquake magnitude is larger.</li>
            </ul>
            (See justification for these choices in <a href="https://doi.org/10.1002/2014JB011280">Métivier et al. (2014).</a>)
        </li>
        <li>For every earthquake, based on its estimated CMT and rupture parameters, co-seismic displacements are calculated at all IGS stations using <a href="https://doi.org/10.1785/BSSA0750041135">Okada (1985)</a>'s approach. Given that the CMT inversion from seismic waves gives rise to two possible solutions for the rupture plane, two possible co-seismic displacements are calculated for every station and earthquake.</li>
        <li> If any calculated 3D co-seismic displacement of an IGS station exceeds 1 mm, it is included in the table below.</li>
    </ul>
    <br>
    <i>Warning:</i> The co-seismic displacements thus calculated rely on several coarse approximations. They should not be used as  estimates of the actual co-seismic displacements, but only as rough orders of magnitude.
    <br><br>
    The column <i>"RF?"</i> in the table below indicates whether each station is part of the current IGS reference frame (IGb20),
hence might need to stop being used as a reference frame station after an earthquake posterior to the end if the IGb20 input data (2024-02-24) occurred.
    <br> <br>
    Table file is downloadable <a :href="coseismic_src" target="_blank">here</a>.
</section> 


<section class="boxsection" id="Table" style="max-width: 95%; margin-bottom: 20px;">
  <TableCoseism class="boxgraphInboxsection"/>
</section>

<FooterLogos/>

</template>

<script>
// @ is an alias to /src
import MenuBoxText from '@/components/MenuBoxText.vue'
import FooterLogos from '@/components/FooterLogos.vue';
import TableCoseism from '@/components/TableCoseism.vue'

//console.log("Current NODE ENV:", process.env.NODE_ENV, "API:", process.env.VUE_APP_api_address)
export default {
  name: 'HomeView',
  components: {
    MenuBoxText,
    FooterLogos,
    TableCoseism
},
data () {
  return{
    coseismic_src : process.env.VUE_APP_api_address + "/coseismic",
  }
},

async mounted(){
/*
  sitelog
  */
 
},
};
</script>


<style>
ul ul {
            list-style-type: circle; /* Different bullet style for nested lists */
            margin-left: 40px; /* Further indentation for nested lists */
        }

</style>
